import { render } from "./stocks.vue?vue&type=template&id=26272013&scoped=true&ts=true"
import script from "./stocks.vue?vue&type=script&lang=ts"
export * from "./stocks.vue?vue&type=script&lang=ts"

import "./stocks.vue?vue&type=style&index=0&id=26272013&lang=less"
import "./stocks.vue?vue&type=style&index=1&id=26272013&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26272013"]])

export default __exports__